export const PERFIL_ELEVACION_MOCK = [
  { distanciaKm: 0, elevacion: 100 },
  { distanciaKm: 2, elevacion: 150 },
  { distanciaKm: 4, elevacion: 300 },
  { distanciaKm: 6, elevacion: 280 },
  { distanciaKm: 8, elevacion: 400 },
  { distanciaKm: 10, elevacion: 380 },
  { distanciaKm: 12, elevacion: 250 },
  { distanciaKm: 14, elevacion: 200 },
  { distanciaKm: 16, elevacion: 320 },
  { distanciaKm: 18, elevacion: 220 },
  { distanciaKm: 20, elevacion: 150 }
];

export const RUNNERS_MOCK = [
  { dorsal: 101, porcentaje: 62 },
  { dorsal: 205, porcentaje: 60 },
  { dorsal: 89, porcentaje: 45 }
];
